import {
  TReceivedInvoiceCondition,
  TSetupConditionProps,
} from '@/context/services/invoice/type';
import { useReceivedInvoiceReconciliationStatusOptions } from '@/features/invoices/hooks/useReceivedInvoiceReconciliationStatusOptions';
import { useRenewalUiReceivedInvoicesFlag } from '@/hooks/feature_flag/useRenewalUiReceivedInvoicesFlag';
import { useTranslation } from '@/i18n';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import { FormSelect, SelectProps } from '@moneyforward/ap-frontend-components';
import { FC, memo, useMemo } from 'react';

export const ReconciliationStatus: FC<TSetupConditionProps> = memo(
  ({ control, name }) => {
    const { t } = useTranslation();
    const flagRenewalUiReceivedInvoices = useRenewalUiReceivedInvoicesFlag();
    const getPopupContainer = useGlobalContainerRef();
    const options = useReceivedInvoiceReconciliationStatusOptions();
    const selectProps: SelectProps = useMemo(
      () => ({
        options: options,
        mode: 'multiple',
        selectAll: false,
        maxTagCount: 1,
        ...(flagRenewalUiReceivedInvoices ? { getPopupContainer } : {}),
      }),
      [options, flagRenewalUiReceivedInvoices, getPopupContainer]
    );
    const labelProps = useMemo(
      () => ({
        text: t('received_invoice_reconciliation'),
      }),
      [t]
    );

    return (
      <FormSelect<TReceivedInvoiceCondition>
        control={control}
        name={name}
        selectProps={selectProps}
        label={labelProps}
        inputId='invoice-search-reconciliation-status'
        testId='invoice-search-reconciliation-status'
      />
    );
  }
);
ReconciliationStatus.displayName = 'ReconciliationStatus';
